export interface Navigation {
  href: string
  key: string
  name: string
  home?: boolean
}

export const homeNavigation: Navigation = {
  name: `XRPL Accelerator`,
  home: true,
  href: `/`,
  key: `home`,
}

export const navigation: Navigation[] = [
  homeNavigation,
  {
    name: `Home`,
    href: `/`,
    key: `back-home`,
  },
  {
    name: `FAQ`,
    href: `/faq`,
    key: `faq`,
  },
  {
    name: `Ecosystem`,
    href: `/ecosystem`,
    key: `ecosystem`,
  },
]
